export default __webpack_public_path__ + "static/chrysoprase-421eb460ee2528cd9cc18d15593c4c03.png";